module.exports = __webpack_public_path__ + "img/4.5125f7ef.jpg";